import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, CardFooter, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import { all } from 'axios';
import { sortBy } from 'lodash';
import PropTypes from 'prop-types';

import { useSession, Form, Button, ErrorBoundary } from '@cordata/buffet';
import { getAccessToken, setAccessToken, removeAccessToken } from '@cordata/buffet/build/helpers/token';

import { sessionInstance as Session } from '~/utils';

const Pre = styled.pre`
  white-space: pre-wrap;
  word-wrap: break-word;
`;

const TermsOfUse = ({ layout, title, ...params }) => {
  const [terms, setTerms] = useState([]);
  const [token, setToken] = useState();
  const { isAuthed, current } = useSession();

  let Base;
  let Header;
  let Body;
  let Footer;

  if ('modal'.startsWith(layout)) {
    Base = Modal;
    Header = ModalHeader;
    Body = ModalBody;
    Footer = ModalFooter;
  } else if ('card'.startsWith(layout)) {
    Base = Card;
    Header = CardHeader;
    Body = CardBody;
    Footer = CardFooter;
  }

  useEffect(() => {
    if (isAuthed) {
      setToken(getAccessToken());
    }
  }, [isAuthed]);

  useEffect(() => {
    if (current && current.attributes.termsOfUseAcceptanceRequired) {
      Session
        .get('pending-terms-of-use')
        .then(r => r.data.data)
        .then(setTerms);
    }
  }, [current]);

  const handleDecline = () => {
    removeAccessToken();

    window.location = '/login';
  };

  return (
    <ErrorBoundary>
      <Form
        displayName="Terms of Use"

        initialValues={{}}

        onSubmit={(values, { setErrors }) =>
          all(terms.map(t =>
            Session
              .post(`pending-terms-of-use/${t.id}/accept`)))
            .then(() => {
              setAccessToken(token);

              window.location = '/home';
            })
            .catch(setErrors)
        }
      >
        {({
          isSubmitting,
          handleSubmit,
        }) => (
          <Base {...params}>
            {title && <Header>{title}</Header>}

            <Body>
              {sortBy(terms, ['attributes.defaultSortOrder']).map((t, i) => (
                <>
                  <Pre>{t.attributes.termsOfUseBody}</Pre>
                  {i !== terms.length - 1 && <hr />}
                </>
              ))}
            </Body>

            <Footer className="d-flex">
              <div className="ml-auto">
                <Button
                  disabled={isSubmitting}
                  outline
                  type="button"
                  color="danger"
                  onClick={handleDecline}
                >
                  Decline
                </Button>

                <Button type="submit" disabled={isSubmitting} onClick={handleSubmit}>
                  Accept{isSubmitting ? 'ing ...' : ''}
                </Button>
              </div>
            </Footer>
          </Base>
        )}
      </Form>
    </ErrorBoundary>
  );
};

TermsOfUse.propTypes = {
  layout: PropTypes.string,
  title: PropTypes.string,
};

TermsOfUse.defaultProps = {
  layout: 'card',
  title: undefined,
};

export default TermsOfUse;
